import * as ActionTypes from 'actions';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  isLoading: false,
};

export default function(state = initialState, action = {}) {
  const { type, response, error } = action;

  switch (type) {
  case ActionTypes.ADD_EVENT_LOAD_REQUEST:
    return { ...state, isLoading: true };

  case ActionTypes.ADD_EVENT_LOAD_SUCCESS: {
    return { ...state, isLoading: false, ...response };
  }

  case ActionTypes.ADD_EVENT_LOAD_FAILURE: {
    console.error('Error loading add event base', error);
    return { ...state, isLoading: false };
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/addEventBase.js